import React from 'react';

const Email = (props) => (
  <>
    {/* Do not touch fill attribute, bacause it will break SVG */}
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9781 19.5001C15.3076 20.6092 13.3145 21.1287 11.3151 20.9761C9.3157 20.8235 7.42453 20.0076 5.94166 18.6578C4.4588 17.308 3.46917 15.5016 3.12981 13.5254C2.79045 11.5491 3.12079 9.51606 4.06843 7.74891C5.01607 5.98175 6.52671 4.58168 8.36067 3.77084C10.1946 2.95999 12.2468 2.78483 14.1917 3.27314C16.1365 3.76145 17.8626 4.88527 19.096 6.46627C20.3294 8.04726 20.9995 9.99488 21 12.0001C21 14.072 20.25 15.7501 18.375 15.7501C16.5 15.7501 15.75 14.072 15.75 12.0001V8.25009"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </>
);

export default Email;
